export default ({
  permissionKeys,
  createResolvers,
  sources,
}) => {
  const permissions = {};
  const resolvers = createResolvers(sources);
  Object.values(permissionKeys).forEach((v) => {
    permissions[v] = resolvers[v] ? resolvers[v]() : undefined;
  });
  return permissions;
};
